import React from 'react';
import './FilterBar.css';

/**
 * FilterBar Component
 * Provides date range and filter controls for the recruiting dashboard
 * All filters displayed in a single horizontal line
 */
function FilterBar({
    startDate,
    endDate,
    department,
    jobTitle,
    onStartDateChange,
    onEndDateChange,
    onDepartmentChange,
    onJobTitleChange,
    departments = [],
    jobTitles = [],
    showDateRange = true,
    showDepartment = true,
    showJobTitle = true,
    onApplyFilters,
    onResetFilters
}) {
    const handleQuickDateRange = (range) => {
        const today = new Date();
        let start, end;

        switch (range) {
            case 'ytd':
                start = new Date(today.getFullYear(), 0, 1);
                end = today;
                break;
            case 'mtd':
                start = new Date(today.getFullYear(), today.getMonth(), 1);
                end = today;
                break;
            case 'last30':
                start = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);
                end = today;
                break;
            case 'last90':
                start = new Date(today.getTime() - 90 * 24 * 60 * 60 * 1000);
                end = today;
                break;
            default:
                return;
        }

        onStartDateChange(start.toISOString().split('T')[0]);
        onEndDateChange(end.toISOString().split('T')[0]);
    };

    return (
        <div className="filter-bar">
            {/* Date Range Inputs */}
            {showDateRange && (
                <>
                    <div className="filter-item">
                        <label className="filter-label">From</label>
                        <input
                            type="date"
                            className="filter-input"
                            value={startDate || ''}
                            onChange={(e) => onStartDateChange(e.target.value)}
                        />
                    </div>
                    <div className="filter-item">
                        <label className="filter-label">To</label>
                        <input
                            type="date"
                            className="filter-input"
                            value={endDate || ''}
                            onChange={(e) => onEndDateChange(e.target.value)}
                        />
                    </div>
                    <div className="filter-quick-dates">
                        <button
                            className="filter-quick-btn"
                            onClick={() => handleQuickDateRange('ytd')}
                            title="Year to Date"
                        >
                            YTD
                        </button>
                        <button
                            className="filter-quick-btn"
                            onClick={() => handleQuickDateRange('mtd')}
                            title="Month to Date"
                        >
                            MTD
                        </button>
                        <button
                            className="filter-quick-btn"
                            onClick={() => handleQuickDateRange('last30')}
                            title="Last 30 Days"
                        >
                            30D
                        </button>
                        <button
                            className="filter-quick-btn"
                            onClick={() => handleQuickDateRange('last90')}
                            title="Last 90 Days"
                        >
                            90D
                        </button>
                    </div>
                    <div className="filter-divider"></div>
                </>
            )}

            {/* Department Filter */}
            {showDepartment && (
                <div className="filter-item">
                    <label className="filter-label">Department</label>
                    <select
                        className="filter-select"
                        value={department || ''}
                        onChange={(e) => onDepartmentChange(e.target.value || null)}
                    >
                        <option value="">All Departments</option>
                        {departments.map((dept) => (
                            <option key={dept} value={dept}>{dept}</option>
                        ))}
                    </select>
                </div>
            )}

            {/* Job Title Filter */}
            {showJobTitle && (
                <div className="filter-item">
                    <label className="filter-label">Job Title</label>
                    <select
                        className="filter-select"
                        value={jobTitle || ''}
                        onChange={(e) => onJobTitleChange(e.target.value || null)}
                    >
                        <option value="">All Job Titles</option>
                        {jobTitles.map((title) => (
                            <option key={title} value={title}>{title}</option>
                        ))}
                    </select>
                </div>
            )}

            {/* Spacer to push buttons to the right */}
            <div className="filter-spacer"></div>

            {/* Action Buttons */}
            <div className="filter-bar-actions">
                {onApplyFilters && (
                    <button className="filter-btn filter-btn-apply" onClick={onApplyFilters}>
                        Apply Filters
                    </button>
                )}
                {onResetFilters && (
                    <button className="filter-btn filter-btn-reset" onClick={onResetFilters}>
                        Reset
                    </button>
                )}
            </div>
        </div>
    );
}

export default FilterBar;
